import { Skeleton, Tooltip, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

type Props = {
  value: number;
  isLoading?: boolean;
};

const GasUsedToTargetRatio = ({ value, isLoading }: Props) => {
  const color = useColorModeValue('#1A1A1A99', '#eeeeee66');
  return (
    <Tooltip label="% of Gas Target">
      <Skeleton color={color} fontWeight="bold" isLoaded={!isLoading}>
        <span>
          {(value > 0 ? '+' : '') +
            value.toLocaleString(undefined, { maximumFractionDigits: 2 })}
          %
        </span>
      </Skeleton>
    </Tooltip>
  );
};

export default React.memo(GasUsedToTargetRatio);
